import { DateTime } from "../DateTime/index.js";
import { ImageThumbnail } from "./index.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/ImageThumbnail/ImageThumbnailWithNameAndDate.tsx
function ImageThumbnailWithNameAndDate({ fileUrl, name, onClick, timestamp }) {
	return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("div", {
		className: "gap-x-xs inline-flex",
		children: [/* @__PURE__ */ jsx(ImageThumbnail, {
			src: fileUrl,
			onClick
		}), /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col text-sm",
			children: [/* @__PURE__ */ jsx("span", {
				className: "font-bold",
				children: name
			}), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(DateTime, { timestamp }) })]
		})]
	}) });
}
//#endregion
export { ImageThumbnailWithNameAndDate };

//# sourceMappingURL=ImageThumbnailWithNameAndDate.js.map